// extracted by mini-css-extract-plugin
export default {"details-item":"details-item--vX0RP","details-item_light":"details-item_light--tm9vH","details-item_dark":"details-item_dark--FtnJE","name":"name--SbHy2","info":"info--KeWJW"};